module.exports = __webpack_public_path__ + "img/instagram.5f64edcf.svg";